import React, { Component } from 'react'
import history from '../../routes/history';
import { connect } from 'react-redux'
import connectCommon from '../common/common-hoc';
import * as actionCreator from '../../redux/actions/data-action';
import { assessmentStatus } from '../../Constants';
import PrevButton from '../../assets/images/back@2x.png';
import NextButton from '../../assets/images/next@2x.png';
import { Box } from '../../third-party-components/material-ui';
import { aiVersions } from '../../Constants';

import {
    AssessmentContainer,
    AssessmentContentHeader,
    AssessmentBody,
    AssessmentNavigationPrevious, 
    AssessmentNavigationNext, 
    AssessmentContent,
    AssessmentContentActionButton,
    AssessmentContentAction,
    AssessmentFooter,
} from './common';
import { getLang } from './common/task-utility';
import { TaskType, TaskSegment } from '../../redux/actions/data-action';

const previousLinkAdditional = "/Demographic/AdditionalQuestions/3";
const nextLink = "/Assessment/Complete";

class AssessmentOmission extends Component {
    constructor(props) {
        super(props);

        this.omittedItems = [];
        this.handleClickNext = this.handleClickNext.bind(this);
        this.handleClickPrevious = this.handleClickPrevious.bind(this);
    }

    componentDidMount() {
        window.history.pushState(null, null, history.location.href);
        window.onpopstate = function (event) {
            history.go(1);
        };

        const { tasks } = this.props;
        const taskIndex = tasks.map(task => task.id).indexOf(TaskType.RATING.id);

        tasks[taskIndex].tasks.filter(task => !task.skipped).forEach((task, index) => {
          if (task.response < -1) {
            this.omittedItems.push((index + 1));
          }
        });
    }

    handleClickPrevious() {
        const { tasks } = this.props;

        var version = parseInt(sessionStorage.getItem('temp-version-id'));

        if (!aiVersions.includes(version)) {
            history.push(`/Demographic/AdditionalQuestions/3`);
        } else {
            const taskIndex = tasks.map(task => task.id).indexOf(TaskType.RATING.id);
            const currentTasks = tasks[taskIndex].tasks.filter(task => !task.skipped);
            const lastIndex = currentTasks.length;
            history.push(`/Assessment/Tasks/${TaskType.RATING.type}/${TaskSegment.TASK}/${lastIndex}`);
        }
    }

    handleClickNext() {
        history.push(nextLink);;
    }

    render() {
        const lang = getLang(this.props.versionID);
        const omittedItems = this.omittedItems.join(', ');
        return (
            <AssessmentContainer>
                <AssessmentContentHeader></AssessmentContentHeader>
                <AssessmentBody>
                    <AssessmentContent className="assessment-content-introduction">
                        {lang === 'fr' ? (
                            <>
                               
                                Vous avez terminé de remplir le test.<br /><br />
                                Vous n’avez pas répondu à la/aux question(s) {omittedItems}.<br /><br />
                                Veuillez cliquer sur la flèche {'<'} pour revenir en arrière et sélectionner une réponse ou cliquer sur la flèche {'>'} pour continuer, sauvegarder vos réponses et les envoyer à votre administrateur.
                            </>
                        ) : lang === 'es' ? (
                            <>
                                Gracias por contestar la evaluación.<br /><br />
                                No respondió el/los ítem(es) {omittedItems}.<br /><br />
                                Por favor haga clic en el botón {'<'} y seleccione una respuesta para el(los) ítem(es) o haga clic en el botón {'>'} para confirmar sus respuestas y enviarlas a su administrador.
                            </>
                        ) : (
                            <>
                                You have completed the assessment.<br/><br/>
                                You did not answer item(s) {omittedItems}.<br/><br/>
                                Please click the back arrow {'<'} and select a response for the item(s) or click the forward arrow {'>'} to save your answers and send them to your administrator.
                            </>
                        )}
                    </AssessmentContent>
                </AssessmentBody>
                <AssessmentContentAction>
                    <AssessmentContentActionButton styleType='arrows' onClick={this.handleClickPrevious}>{"<"}</AssessmentContentActionButton>
                    <AssessmentContentActionButton styleType='arrows' onClick={this.handleClickNext}>{">"}</AssessmentContentActionButton>
                </AssessmentContentAction>
                <AssessmentFooter></AssessmentFooter>
            </AssessmentContainer>
        )
    }
}

const mapStateToProps = (state, ownState) => ({
  tasks: state.data.tasks,
  versionID: state.data.versionID
});

export default connect(mapStateToProps, actionCreator)(connectCommon(AssessmentOmission));
